var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 2.00033C13.6667 2.9208 12.9205 3.66699 12 3.66699C11.0795 3.66699 10.3333 2.9208 10.3333 2.00033C10.3333 1.07985 11.0795 0.333659 12 0.333659C12.9205 0.333659 13.6667 1.07985 13.6667 2.00033ZM8.66668 2.00033C8.66668 2.9208 7.92048 3.66699 7.00001 3.66699C6.07954 3.66699 5.33334 2.9208 5.33334 2.00033C5.33334 1.07985 6.07954 0.333659 7.00001 0.333659C7.44204 0.333659 7.86596 0.509254 8.17852 0.821814C8.49108 1.13437 8.66668 1.5583 8.66668 2.00033ZM3.66668 2.00033C3.66668 2.9208 2.92048 3.66699 2.00001 3.66699C1.07954 3.66699 0.333344 2.9208 0.333344 2.00033C0.333344 1.07985 1.07954 0.333659 2.00001 0.333659C2.44204 0.333659 2.86596 0.509254 3.17852 0.821814C3.49108 1.13437 3.66668 1.5583 3.66668 2.00033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.97cafd4fdff86be68c75f70f95c0943c.svg";
export { ForwardRef as ReactComponent };